import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { PulseLoader } from '@checkmarx/cx-ui';

export default class ScreenLoaderContainer extends Component {

    state = {
        height: 'auto'
    };

    componentDidMount() {

        const div = ReactDOM.findDOMNode(this.refs.wrapperDiv);
        const parent = div.parentElement;

        if (parent) {

            this.setState({
                height: parent.clientHeight
            });
        }   
    }

    render(){

        return(
            <div className='screen-loader-main-wrapper' ref='wrapperDiv' style={{
                height: this.state.height
            }}>
                <PulseLoader color={'#373050'} loading={true} />
            </div>
        );
    }
}